module.exports = __webpack_public_path__ + "img/yaoqing-pic@3x.9e4c7705.png";